import React from "react";
import { Container } from "react-bootstrap";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";
const GuiasTrabajoOnSite = () => {
  const bucketUrl = process.env.REACT_APP_BUCKET;
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="container text-center">
          <div className="row">
            <div className="col">
              <div className="TituloPrincipal">
                <br /> <h1>Guías Trabajo On Site</h1>
              </div>
              <center>
                <hr className="linea-horizontal"></hr>
              </center>
            </div>
            <div className="col">
              <div className="Text_Buttons_Radio_buttons">
              </div>
            </div>
          </div>
        </div>

        <div class="table-container">
          <table class="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre Del Proceso</th>
                <th>Descripción</th>
                <th>Documentación</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <p>   
                    <b>Instalación de Software</b>
                  </p>
                </td>
                <td>
                  <p>
                    Guía
                  </p>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/InstalacionSoftware_001.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Formato
                  </a>{" "}
                </td>
              </tr>

              <tr>
                <td>2</td>
                <td>
                  <p>
                    <b>Mantenimiento Correctivo </b>
                  </p>
                </td>

                <td>
                  <p>
                    Guía
                  </p>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/Manto-Correctivo_001.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Formato
                  </a>{" "}
                </td>
              </tr>  


              <tr>  
                <td>3</td>
                <td>
                  <p>   
                    <b>Mantenimiento Preventivo</b>
                  </p>
                </td>  
                <td>
                  <p>
                  Guía
                  </p>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/Manto-Preventivo_001.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Formato
                  </a>{" "}
                </td>
              </tr>


              <tr>  
                <td>4</td>
                <td>
                  <p>   
                    <b>PoCs</b>
                  </p>
                </td>  
                <td>
                  <p>
                  Guía
                  </p>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/PoCs_001.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Formato
                  </a>{" "}
                </td>
              </tr>


              <tr>  
                <td>5</td>
                <td>
                  <p>   
                    <b>Site Survey</b>
                  </p>
                </td>  
                <td>
                  <p>
                  Guía
                  </p>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/SiteSurvey_001.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Formato
                  </a>{" "}
                </td>
              </tr>

              
            </tbody>
          </table>
        </div>
      </Container>
    </>
  );
};

export default GuiasTrabajoOnSite;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
